import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _CacheProvider;
export class CacheProvider {
  constructor() {
    _defineProperty(this, "cache", {});
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new CacheProvider();
    }
    return this.instance;
  }
  set(key, value) {
    this.cache[key] = value;
  }
  clear(key) {
    delete this.cache[key];
  }
  clearAll() {
    this.cache = {};
  }
  get(key) {
    return this.cache[key];
  }
  async getOrDefault(key, func) {
    const result = this.get(key);
    if (result) {
      return result;
    }
    const value = await func();
    this.set(key, value);
    return value;
  }
}
_CacheProvider = CacheProvider;
_defineProperty(CacheProvider, "instance", void 0);
_defineProperty(CacheProvider, "CPP_ORG_CACHE_KEY", "cpp_organization");